import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import Fab from '@material-ui/core/Fab';

import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';

import {BUTTON_TYPES} from '../../../constants/dialogButtonTypes';

class MultiDeleteButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getContent = this.getContent.bind(this);
        this.getIcon = this.getIcon.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            open: false
        };
    }

    getContent() {
        if (this.props.type === BUTTON_TYPES.ARCHIVE.key) {
            return <FormattedMessage id="common.archiveMultiConfirm"/>;
        } else if (this.props.type === BUTTON_TYPES.UNARCHIVE.key) {
            return <FormattedMessage id="common.unarchiveMultiConfirm"/>;
        } else {
            return <FormattedMessage id="common.deleteMultiConfirm"/>;
        }
    }

    getIcon() {
        if (this.props.type === BUTTON_TYPES.ARCHIVE.key) {
            return <ArchiveIcon/>;
        } else if (this.props.type === BUTTON_TYPES.UNARCHIVE.key) {
            return <UnarchiveIcon/>;
        } else {
            return <DeleteSweepIcon/>;
        }
    }

    handleClose() {
        this.setState({open: false});
    }

    handleOpen() {
        this.setState({open: true});
    }

    render() {
        return (
            <Fab
                disabled={this.props.disabled}
                onClick={this.state.open ? null : this.handleOpen}
                size="small"
            >
                {this.getIcon()}
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent>
                        <div className="side-padding">
                            {this.getContent()}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.props.onSubmit(this.props.data).then(() => this.handleClose())}>
                            <FormattedMessage id="buttons.confirm"/>
                        </Button>
                        <Button onClick={this.handleClose}>
                            <FormattedMessage id="buttons.cancel"/>
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fab>
        );
    }
}

MultiDeleteButton.propTypes = {
    data: PropTypes.array,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]).isRequired,
    type: PropTypes.string
};

export default MultiDeleteButton;


// WEBPACK FOOTER //
// ./src/components/common/button/MultiDeleteButton.js